// extracted by mini-css-extract-plugin
export default {"container":"style_container__x2jGz","nav_links":"style_nav_links__PXuw5"};